import { memo } from 'react'
import { NewCarousel } from 'components/Carousels/NewCarousel'
import { TABS_ID_PREFIX, LENDING_VARIANT } from './constants'
import { ItemComponentCarousel } from './ItemComponentCarousel'
import { TrustPilotBadge } from './TrustPilotBadge'

const TabsCarousel = memo(
  ({ items, tabStyle, isUserActive, isInView, onSlideChange, carouselRef, trustPilot }) => {
    return (
      <>
        <div className={tabStyle === LENDING_VARIANT ? 'w-full items-end' : 'w-full py-5'}>
          <NewCarousel
            showButtons={false}
            indicatorsContainerClass={
              tabStyle === LENDING_VARIANT ? 'hidden' : 'lg:hidden bottom-[-32px]'
            }
            autoPlay={isUserActive && isInView}
            cbOnChange={onSlideChange}
            ref={carouselRef}
            idPrefix={TABS_ID_PREFIX}
            items={items.map((item, pos) => {
              return (
                <div
                  key={`slide-${pos}`}
                  className={
                    tabStyle == LENDING_VARIANT
                      ? 'h-full flex items-center justify-center lg:justify-end flex-1 overflow-hidden'
                      : 'h-full flex items-center justify-center'
                  }
                >
                  <ItemComponentCarousel
                    item={item}
                    idPrefix={TABS_ID_PREFIX}
                    data-testid={`${TABS_ID_PREFIX}-item`}
                    selected={`${item?.sys?.id}-${pos}`}
                    index={pos}
                    tabStyle={tabStyle}
                  />
                </div>
              )
            })}
            interval={5000}
          />
        </div>
        <TrustPilotBadge
          trustPilot={trustPilot}
          className="pt-6 pb-8  items-center justify-center flex lg:hidden lg:justify-start"
        />
      </>
    )
  }
)
TabsCarousel.displayName = 'TabsCarousel'

export { TabsCarousel }
